/**
 * FH-A11Y batch 12 (2026-09-26): polish items from the Orca walkthrough.
 * Home page had two level-1 headings; product accordions were read as "+ Product Details";
 * the mobile filter drawer had a silent Tab stop and was read as one run-on string; the cart page's
 * Remove control was a link while the drawer's is a button.
 * Rollback: remove the ada-a11y-batch12.js line at the end of snippets/freshdesk.liquid.
 */
(function () {
  'use strict';
  if (window.__fhA11yBatch12) return;
  window.__fhA11yBatch12 = true;

  function setAttr(el, name, value) {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }
  function removeAttr(el, name) {
    if (el.hasAttribute(name)) el.removeAttribute(name);
  }
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  /* Home page: the header logo is already the level-1 heading ("Fab Habitat"), so the promo banner
     heading goes back to level 2. (An earlier batch promoted it when it only checked the main area.) */
  function fixHomeH1() {
    if (!document.querySelector('header h1, .header h1')) return;
    document.querySelectorAll('main h2[aria-level="1"]').forEach(function (h) { removeAttr(h, 'aria-level'); });
  }

  /* Product accordions: the "+" / "-" is drawn with CSS, so it was read as "+ Product Details". */
  function fixAccordions() {
    document.querySelectorAll('summary .accordion__title').forEach(function (t) {
      var s = t.closest('summary');
      var name = txt(t);
      if (s && name) setAttr(s, 'aria-label', name);
    });
  }

  /* Mobile filter drawer (Globo): its scrolling list was an extra, silent Tab stop in Firefox, and with
     no description screen readers read the whole drawer as one run-on string when it opened. */
  function fixFilterDrawer() {
    var tree = document.getElementById('gf-tree');
    if (!tree) return;
    tree.querySelectorAll('.gf-filter-contents').forEach(function (c) { setAttr(c, 'tabindex', '-1'); });
    if (tree.getAttribute('role') === 'dialog') {
      var d = document.getElementById('fh-gf-tree-desc');
      if (!d) {
        d = document.createElement('span');
        d.id = 'fh-gf-tree-desc';
        d.className = 'visually-hidden';
        d.textContent = 'Filters apply as soon as you choose them. Close the filters to see the products.';
        tree.appendChild(d);
      }
      setAttr(tree, 'aria-describedby', 'fh-gf-tree-desc');
    }
  }

  /* Cart page: Remove was a link (Remove in the cart drawer is a button). Make it a button, with Space too. */
  function fixCartRemove() {
    document.querySelectorAll('cart-remove-button > a').forEach(function (a) {
      setAttr(a, 'role', 'button');
      if (a.__fh12) return;
      a.__fh12 = true;
      a.addEventListener('keydown', function (e) {
        if (e.key !== ' ' && e.key !== 'Spacebar') return;
        e.preventDefault();
        a.click();
      });
    });
  }

  function runAll() {
    try { fixHomeH1(); } catch (e) {}
    try { fixAccordions(); } catch (e) {}
    try { fixFilterDrawer(); } catch (e) {}
    try { fixCartRemove(); } catch (e) {}
  }

  var timer = 0;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = 0; runAll(); }, 60);
  }

  function start() {
    runAll();
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('load', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
